<div class="gtt-modal-content">
  <div class="gtt-modal-header">
    <h3 class="gtt-modal-title">Genera Test Settings</h3>
    <button type="button" class="gtt-close-button" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
  <div class="gtt-modal-body" *ngIf="inferenceParams">
    <div *ngIf="isAdmin$ | async">
      <!-- Inference Model Selection -->
      <div class="gtt-form-group">
        <label for="modelmodal" class="gtt-label">Inference Model</label>
        <ng-select id="modelmodal" placeholder="Seleziona modello" [items]="models$ | async"
          [(ngModel)]="inferenceParams.model" (ngModelChange)="onModelChange()" [clearable]="false">
        </ng-select>
      </div>

      <hr class="my-4">
      <h5 class="mb-3">Inference Parameters</h5>

      <!-- Temperature Slider -->
      <div class="gtt-form-group">
        <label for="temperature" class="gtt-label">Temperature</label>
        <div class="d-flex align-items-center">
          <input id="temperature" type="range" class="form-range" min="0" max="2" step="0.1"
            [(ngModel)]="inferenceParams.temperature" (ngModelChange)="onParamsChange()">
          <span class="ml-1 ms-3 fw-bold" style="min-width: 40px;">{{ inferenceParams.temperature | number:'1.1-1'
            }}</span>
        </div>
        <small class="form-text text-muted">Controls randomness. Lower values are more deterministic.</small>
      </div>

      <!-- Top P Slider -->
      <div class="gtt-form-group mt-3">
        <label for="top_p" class="gtt-label">Top P</label>
        <div class="d-flex align-items-center">
          <input id="top_p" type="range" class="form-range" min="0" max="1" step="0.01"
            [(ngModel)]="inferenceParams.top_p" (ngModelChange)="onParamsChange()">
          <span class="ml-1 ms-3 fw-bold" style="min-width: 40px;">{{ inferenceParams.top_p | number:'1.2-2' }}</span>
        </div>
        <small class="form-text text-muted">Nucleus sampling. Considers a smaller, more probable set of tokens.</small>
      </div>

      <!-- ========================================================== -->
      <!-- NUOVA SEZIONE CONDIZIONALE PER I CONTROLLI DEL "THINKING"   -->
      <!-- ========================================================== -->

      <!-- SEZIONE 1: Mostra se il modello usa 'thinking_level' (es. Gemini 3) -->
      <div *ngIf="modelConfig?.controlType === 'level'" class="gtt-form-group mt-4">
        <label for="thinkingLevel" class="gtt-label">Thinking Level</label>
        <ng-select id="thinkingLevel" [items]="modelConfig.levels" [(ngModel)]="inferenceParams.thinking_level"
          (ngModelChange)="onParamsChange()" [searchable]="false" [clearable]="false">
        </ng-select>
        <small class="form-text text-muted">
          Controls reasoning behavior. 'High' is recommended for complex tasks.
        </small>
      </div>

      <!-- SEZIONE 2: Mostra se il modello usa 'thinking_budget' (es. Gemini 2.5) -->
      <div *ngIf="modelConfig?.controlType === 'budget'" class="gtt-form-group mt-4">
        <label class="gtt-label">Thinking Budget</label>

        <div class="form-check form-switch mb-2">
          <input class="form-check-input" type="checkbox" role="switch" id="dynamicBudgetSwitch"
            [(ngModel)]="isDynamicBudget" (ngModelChange)="onDynamicBudgetToggle()"
            [disabled]="!modelConfig.canBeDisabled">
          <label class="form-check-label" for="dynamicBudgetSwitch">
            Dynamic Budget (Recommended)
          </label>
        </div>

        <div class="d-flex align-items-center mt-2">
          <!-- Slider -->
          <input id="thinking_budget_slider" type="range" class="form-range" [min]="modelConfig.minBudget"
            [max]="modelConfig.maxBudget" [step]="modelConfig.step" [(ngModel)]="inferenceParams.thinking_budget"
            (ngModelChange)="onParamsChange()" [disabled]="isDynamicBudget">

          <!-- Input numerico -->
          <div class="ml-1 ms-3" style="min-width: 120px; text-align: center;">
            <span *ngIf="isDynamicBudget; else manualInput" class="fw-bold">Dynamic</span>
            <ng-template #manualInput>
              <input type="number" class="form-control form-control-sm text-center" id="thinking_budget_input"
                [min]="modelConfig.minBudget" [max]="modelConfig.maxBudget" [step]="modelConfig.step"
                [(ngModel)]="inferenceParams.thinking_budget" (ngModelChange)="onParamsChange()"
                (blur)="validateBudgetInput()" [disabled]="isDynamicBudget">
            </ng-template>
          </div>
        </div>

        <small class="form-text text-muted">
          Controls reasoning tokens. Rules change based on the selected model.
        </small>
      </div>

      <!-- SEZIONE 3: Non mostra nulla se controlType è 'none' (es. GPT-5) -->

      <hr class="my-4">
    </div>
    <div class="gtt-form-group">
      <label for="templatemodal" class="gtt-label">Template</label>
      <ng-select id="templatemodal" placeholder="Seleziona un template" [items]="templateNames$ | async"
        [(ngModel)]="selectedTemplate" [clearable]="false" (change)="updateSelectedTemplate()">
      </ng-select>
    </div>

    <!-- Test Generation Batch Size -->
    <div class="gtt-form-group mt-3">
      <label for="batchSize" class="gtt-label">Test Generation Batch Size</label>
      <input id="batchSize" type="number" class="form-control" min="1" max="50" [(ngModel)]="testGenerationBatchSize"
        (ngModelChange)="updateBatchSize()">
      <small class="form-text text-muted">Limits concurrent API calls to prevent server overload.</small>
    </div>

    <!-- SEPARATOR FOR NEW SECTION -->


    <!-- NEW PROMPT EDITING SECTION -->
    <div class="gtt-form-group" *ngIf="isAdmin$ | async">
      <hr class="my-4">

      <label class="gtt-label">Prompt Customization</label>
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="customPromptCheck" [(ngModel)]="isCustomPromptForTestGen"
          (ngModelChange)="toggleCustomPrompt()">
        <label class="form-check-label" for="customPromptCheck">
          Use Custom Prompt for Test Generation
        </label>
      </div>

      <!-- Show Edit button only if the checkbox is checked -->
      <div *ngIf="isCustomPromptForTestGen" class="mt-3">
        <button class="btn btn-outline-primary" (click)="openPromptEditor()">
          <i class="ft-edit"></i> Edit Prompt
        </button>
      </div>
    </div>

  </div>
  <div class="gtt-modal-footer">
    <!-- Optional: Add a button to explicitly close the modal -->
    <button class="btn btn-secondary" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>

<!-- ==================================================================== -->
<!-- TEMPLATE FOR THE FULL-SCREEN PROMPT EDITOR MODAL (INVARIATO)         -->
<!-- ==================================================================== -->
<ng-template #promptEditorModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Edit Prompt for Test Generation</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="promptToEdit">
      <!-- System Prompt Editor -->
      <div class="mb-4">
        <label for="systemPrompt" class="form-label fs-5 fw-bold">System Prompt</label>
        <p class="text-muted small">This message sets the behavior and personality of the AI assistant.</p>
        <textarea id="systemPrompt" class="form-control font-monospace" rows="12" [(ngModel)]="promptToEdit.system">
          </textarea>
      </div>

      <!-- User Prompt Editor -->
      <div>
        <label for="userPrompt" class="form-label fs-5 fw-bold">User Prompt</label>
        <p class="text-muted small">This is the actual instruction or question you are giving.</p>
        <textarea id="userPrompt" class="form-control font-monospace" rows="18" [(ngModel)]="promptToEdit.user">
          </textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="modal.close('save')">Save Prompt</button>
  </div>
</ng-template>